
import { Vue, Component, Prop, Watch  } from 'vue-property-decorator';
@Component
export default class BaseInput extends Vue {
	@Prop({default: 'primary'}) public readonly variant!: string;
	@Prop({default: 'Loading'}) public readonly label!: string;
}
